export const isLocal = false;
export const API_HOST = isLocal
  ? "http://localhost:8080"
  : process.env.REACT_APP_API_HOST;
